/**
 * Lightweight event-bus toast helper.
 * Works from both React components (via hook or direct import)
 * and non-React contexts such as Redux slice middleware.
 */

const listeners = new Set();

const emit = (type, message) => {
  listeners.forEach((fn) => fn({ type, message }));
};

const toast = {
  success: (message) => emit("success", message),
  error: (message) => emit("error", message),
  info: (message) => emit("info", message),
  warning: (message) => emit("warning", message),
  /** Subscribe to toast events. Returns an unsubscribe function. */
  subscribe: (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};

export default toast;
